// The ReelsetController class manages the animation and state of a set of reels in a slot game.
class ReelsetController {
  // Constructor initializes the reel controllers, animation state, and callback functions.
  constructor(reelRefs, handleSetLinesRotation, handleSetCurrentWinningLine) {
    this.reelControllers = reelRefs.map((reelRef) => reelRef);
    this.isAnimating = false;
    this.setLinesRotationFinished = handleSetLinesRotation;
    this.setCurrentWinningLine = handleSetCurrentWinningLine;
  }

  matchHorizontalWinningLines(winningLines, wins) {
    const result = {};
    wins.forEach((win) => {
      const { id, positions, symbol } = win;
      if (!result[id]) {
        result[id] = {
          line: winningLines[id],
          positions: [],
          symbol,
        };
      }
      result[id].positions.push(...positions);
    });
    return result;
  }

  async startWinningLinesAnimation(winningData) {
    this.setLinesRotationFinished(false);
    this.isAnimating = true;
    const lineIds = Object.keys(winningData);
    this.dimAllSymbols();

    const animateWinningLine = (lineId, index) => {
      return new Promise((resolve) => {
        const data = winningData[lineId];
        this.setCurrentWinningLine(index + 1);
        data.positions.forEach(([reelIndex, symbolIndex]) => {
          const symbol =
            this.reelControllers[reelIndex].symbolsContainer.children[
              symbolIndex + 1
            ];
          this.reelControllers[reelIndex].animateWinningSymbol(
            symbol,
            symbolIndex
          );
          this.reelControllers[reelIndex].toggleSymbolVisibility(symbol, "dim");
        });
        if (lineId !== "scatter") {
          data.line.forEach((symbolIndex, reelIndex) => {
            const symbol =
              this.reelControllers[reelIndex].symbolsContainer.children[
                symbolIndex + 1
              ];
            this.reelControllers[reelIndex].animateWinBox(symbol);
          });
        }

        setTimeout(resolve, 2000);
      });
    };

    for (const [index, lineId] of lineIds.entries()) {
      if (!this.isAnimating) return;
      this.hideAllWinningSymbols();
      this.dimAllSymbols();
      this.hideAllWinBoxes();
      await animateWinningLine(lineId, index);
    }

    if (this.isAnimating) {
      this.setLinesRotationFinished(true);
    }
  }

  stopWinningLinesAnimation() {
    this.isAnimating = false;
    this.unDimAllSymbols();
    this.removeWinBoxes();
  }

  hideAllWinningSymbols = () => {
    this.reelControllers.forEach((reelController) => {
      reelController.hideWinningSymbols();
    });
  };

  dimAllSymbols() {
    this.reelControllers.forEach((reelController) => {
      reelController.dimAllSymbols();
    });
  }

  unDimAllSymbols() {
    this.reelControllers.forEach((reelController) => {
      reelController.removeSpineAnimations("dim");
    });
  }

  removeWinBoxes() {
    this.reelControllers.forEach((reelController) => {
      reelController.removeSpineAnimations("winBox");
    });
  }

  hideAllWinBoxes() {
    this.reelControllers.forEach((reelController) => {
      reelController.hideSymbolElements("winBox");
    });
  }
}

export default ReelsetController;
